import { useState } from 'react';
import MainInfo from '../components/sveden/MainInfo';
import Documents from '../components/sveden/Documents';
import Education from '../components/sveden/Education';
import Management from '../components/sveden/Management';
import Teachers from '../components/sveden/Teachers';
import PaidServices from '../components/sveden/PaidServices';

const tabs = [
  { id: 'main', label: 'Основные сведения', component: MainInfo },
  { id: 'docs', label: 'Документы', component: Documents },
  { id: 'edu', label: 'Образование', component: Education },
  { id: 'management', label: 'Руководство', component: Management },
  { id: 'teachers', label: 'Педагогический состав', component: Teachers },
  { id: 'paid', label: 'Платные образовательные услуги', component: PaidServices }
];

const SvedenPage = () => {
  const [activeTab, setActiveTab] = useState('main');
  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="container page-container">
      <div className="page-kicker"><p className="eyebrow"><span /> открытая информация</p></div>
      <h1 className="page-title">Сведения об<br /><em>образовательной организации</em></h1>
      <div className="tabs-wrap"><div className="tabs-list">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`tab-button ${
                activeTab === tab.id
                  ? 'is-active'
                  : ''
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div></div>
      <div className="content-card">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default SvedenPage;
